const comm = {

    /**
     * 生成32位UUID
     */
    newGuid() {
        var guid = "";
        for (var i = 1; i <= 32; i++) {
            var n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
        }
        return guid;
    },

    /**
     * 高度
     */
     difHeightFun(vals){
        let heights = null;
        let difHeight = localStorage.getItem('difHeight');
        let curHeight;
        if(document.querySelector(".innerBg")){
            curHeight = document.querySelector(".innerBg").offsetHeight;
        }else{
            curHeight = 0;
        }

        let dif = Number(difHeight) - Number(curHeight);
        if(vals <= dif){
            heights = dif+'px';
        }else{
            heights = "auto";
        }
        return heights;
    },
    // 获取当前日期 
    getCurrentDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    getNavIndexByChannelId(channelId) {
        const channelMap = {
            '53': 1, '15': 2, '8': 3, '9': 4, '11': 5, '7': 6, '12': 7,
            'd8': 8, 'd9': 9, 'd10': 10
        };
        return channelMap[channelId] || 2; // 默认最新新闻
    },
    // 根据栏目类型获取对应的路由路径
    getRoutePathByColumnType(columnType) {
        const routeMap = {
            1: '/newsPage',        // 新闻
            2: '/merchantView',    // 商家
            3: '/recruitmentIndex', // 招聘
            4: '/easyBookView'     // 易书
        };
        return routeMap[columnType] || '/newsPage'; // 默认新闻页面
    },
    navigateToArticle(data, routerInstance) {
        let indexs = null, channelIds = null, path = '';
        const channelMap = {
            '53': 1, '15': 2, '8': 3, '9': 4, '11': 5, '7': 6, '12': 7,
            'd8': 8, 'd9': 9, 'd10': 10
        };
        const columnType = data.newsInfo.columnType;
        const columnPath = data.newsInfo.columnPath;
        if (columnType == 2) {
            indexs = 8;
            channelIds = 'd8';
            path = '/merchantView';
        } else if (columnType == 3) {
            indexs = 9;
            channelIds = 'd9';
            path = '/recruitmentIndex';
        } else if (columnType == 4) {
            indexs = 10;
            channelIds = 'd10';
            path = '/easyBookView';
        } else {
            indexs = channelMap[columnPath];
            // indexs = channelMap[columnPath] || 0;
            channelIds = columnPath;
            path = '/newsPage';
        }
        routerInstance.push({
            path: path,
            query: {
                newsCode: data.newsCode, 
                channelId: channelIds,
                index: indexs
            }
        });
    },
   /**
     * 新闻时间格式化 - 统一相对时间直到半年
     * 规则：
     * 1. 当天：具体时间 (14:30)
     * 2. 昨天：显示"昨天"
     * 3. 7天内：显示"X天前"
     * 4. 30天内：显示"X周前" 
     * 5. 180天内：显示"X月前"
     * 6. 超过180天：完整日期 (2025-12-11)
     */
    formatNewsTime(timeStr) {
        if (!timeStr) return '';
        
        const now = new Date();
        const newsTime = new Date(timeStr.replace(/-/g, '/'));
        
        if (isNaN(newsTime.getTime())) {
            console.warn('Invalid date:', timeStr);
            return timeStr;
        }
        
        const diffMs = now - newsTime;
        
        // 如果是未来时间
        if (diffMs < 0) {
            return '刚刚';
        }
        
        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHour = Math.floor(diffMin / 60);
        const diffDay = Math.floor(diffHour / 24);
        
        // 计算月份差（更准确）
        const monthDiff = (now.getFullYear() - newsTime.getFullYear()) * 12 + 
                        (now.getMonth() - newsTime.getMonth());
        
        // 计算天数用于周和月判断
        const dayDiff = diffDay;
        
        // 格式化时间
        const padZero = (num) => num.toString().padStart(2, '0');
        
        // 1. 今天内
        if (diffDay === 0) {
            if (diffHour === 0) {
                if (diffMin === 0) return '刚刚';
                if (diffMin < 5) return '几分钟前';
                return `${diffMin}分钟前`;
            }
            return `${padZero(newsTime.getHours())}:${padZero(newsTime.getMinutes())}`;
        }
        
        // 2. 昨天
        if (diffDay === 1) {
            return '昨天';
        }
        
        // 3. 7天内
        if (diffDay <= 7) {
            return `${diffDay}天前`;
        }
        
        // 4. 4周内（约30天）
        if (diffDay <= 30) {
            const week = Math.floor(diffDay / 7);
            return `${week}周前`;
        }
        
        // 5. 6个月内（约180天） - 显示月前
        if (diffDay <= 180) {
            // 使用月份差
            if (monthDiff === 0) {
                return '1个月前'; // 不足1个月但超过30天
            }
            return `${monthDiff}个月前`;
        }
        
        // 6. 超过6个月 - 显示完整日期
        // 如果是今年，可以省略年份
        if (now.getFullYear() === newsTime.getFullYear()) {
            return `${padZero(newsTime.getMonth() + 1)}-${padZero(newsTime.getDate())}`;
        }
        
        // 跨年显示完整日期
        return `${newsTime.getFullYear()}-${padZero(newsTime.getMonth() + 1)}-${padZero(newsTime.getDate())}`;
    },
    /**
     * 新闻时间格式化（更符合新闻阅读习惯）
     */
    formatNewsTime111(timeStr) {
        if (!timeStr) return '';
        
        const now = new Date();
        const newsTime = new Date(timeStr.replace(/-/g, '/'));
        
        if (isNaN(newsTime.getTime())) return timeStr;
        
        // 计算差异
        const diffMs = now - newsTime;
        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHour = Math.floor(diffMin / 60);
        const diffDay = Math.floor(diffHour / 24);
        const diffMonth = Math.floor(diffDay / 30);
        
        // 判断是否同一年
        const isSameYear = now.getFullYear() === newsTime.getFullYear();
        
        // 格式化辅助函数
        const padZero = (num) => num.toString().padStart(2, '0');
        
        // 1. 1小时内：显示相对时间
        if (diffHour === 0) {
            if (diffMin === 0) return '刚刚';
            if (diffMin < 10) return '几分钟前';
            return `${diffMin}分钟前`;
        }
        
        // 2. 今天内：显示具体时间
        if (diffDay === 0) {
            return `${padZero(newsTime.getHours())}:${padZero(newsTime.getMinutes())}`;
        }
        
        // 3. 昨天：显示"昨天 + 时间"
        if (diffDay === 1) {
            return `昨天 ${padZero(newsTime.getHours())}:${padZero(newsTime.getMinutes())}`;
        }
        
        // 4. 7天内：显示"周X + 时间"
        if (diffDay <= 7) {
            const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
            const weekday = weekdays[newsTime.getDay()];
            return `${weekday} ${padZero(newsTime.getHours())}:${padZero(newsTime.getMinutes())}`;
        }
        
        // 5. 一个月内：显示"X天前"
        if (diffDay <= 30) {
            return `${diffDay}天前`;
        }
        
        // 6. 同一年内：显示"月-日"
        if (isSameYear) {
            return `${padZero(newsTime.getMonth() + 1)}-${padZero(newsTime.getDate())}`;
        }
        
        // 7. 跨年：显示完整日期
        return `${newsTime.getFullYear()}-${padZero(newsTime.getMonth() + 1)}-${padZero(newsTime.getDate())}`;
    },
}
export default comm


// WEBPACK FOOTER //
// ./src/utils/comm.js